// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iQup","input":"styles_input__2eU08"};